"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GooglePayInput;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function GooglePayInput() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "googlepaybutton"
  });
}